// extracted by mini-css-extract-plugin
module.exports = {"SurfaceSection":"SurfaceSection_SurfaceSection__VixJT"};